import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useDispatch } from 'react-redux';

import {
  initializeAuth,
  setQueryParams
} from './components/store/slices/ideaSubmissionSlice';

import IdeaSubmissionApp from './components/apps/IdeaSubmissionApp/IdeaSubmissionApp';
import Home from './components/apps/Home/Home';
import ideaSubmissionConfig from './idea_submission.json';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function AppRenderer() {
  const dispatch = useDispatch();

  useEffect(() => {
    // 1️⃣ Initialize anonymous auth
    dispatch(initializeAuth());

    // 2️⃣ Capture ALL query params on app load
    const params = Object.fromEntries(
      new URLSearchParams(window.location.search).entries()
    );

    // 3️⃣ Store them in Redux
    dispatch(setQueryParams(params));
  }, [dispatch]);

  return (
    <Router>
      <Toaster position="top-center" />

      <Routes>
        <Route path="/" element={<Home />} />

        <Route
          path="/submit"
          element={<IdeaSubmissionApp data={ideaSubmissionConfig.data} />}
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default AppRenderer;
